import './LandingHeader.scss'
import React from 'react'

import headerLogoWhite from '../../../Assets/icons/logo.svg'

const LandingHeader = () => {
  return(
    <>
      <header className={`welcome-header`}>
        <div className="d-flex justify-content-center align-items-center w-100">
          <div className="d-flex align-items-center">
            <img width={35} src={headerLogoWhite} alt=""/>
            <span className="logo-title">Comment8</span>
          </div>
        </div>
      </header>
    </>
  )
}
export default LandingHeader
